import axios from 'axios';
import WebApiService from '../services/WebApiService';

export default class MediaService extends WebApiService {

    constructor() {
        super();
    }

    getTutorialManifest(callback, errorCallback) {
        delete axios.defaults.headers.Authorization;
        axios.get(window.__globalConfig.baseUrl + '/Content/Videos/tutorialmanifest.json').then((res) => {
            callback(res.data);
        }).catch((err) => { });
    }
}